import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthenticationService } from '../services/authentication.service';
import Swal from 'sweetalert2';
import moment from 'moment'
import { NgxSpinnerService } from 'ngx-spinner';



@Component({
  selector: 'app-my-ads',
  templateUrl: './my-ads.component.html',
  styleUrls: ['./my-ads.component.css'],
})
export class MyAdsComponent implements OnInit {
  subscriptionPlan:any;
  bannerPlan:any;
  constructor(
    public router: Router,
    public authenticationService: AuthenticationService,
    private route: ActivatedRoute,
    private spinner: NgxSpinnerService
  ) { }

  ngOnInit(): void {
    this.getProfile();

   }
   redirectTo(path:any){
    let params = {};
    if(!this.subscriptionPlan && path !== '/mysubscration') {
      return Swal.fire(
        "Oops...",
        "Your subscription plan is currently inactive or not a paid plan. Please renew your subscription to continue enjoying our services.",
        "error"
      )
    }
    if(path == '/mysubscration') params = {isSub: true}
    else  params = {}
    if(this.bannerPlan?.length > 0 && path == '/my-banner-plans') {
      this.router.navigate(['/banner-ads']);
    } else if(this.bannerPlan?.length == 0 && path == '/my-banner-plans') {
        this.router.navigate(['/my-banner-plans']);  
    } else {
      this.router.navigate([path], { queryParams: params });
    }
    
   }
   getProfile() {
    this.bannerPlan = [];
    this.authenticationService.getProfile().subscribe(
      (response: any) => {
        if (response && response?.data) {
          this.subscriptionPlan = response?.data?.subscriptionPlanType;
          this.bannerPlan = response?.data?.bannerPlanType;
          console.log(response?.data, 'data')
        }
      },
      (error) => {
        console.error(error)
      }
    )
  }
}



// redirectTo(){
//   this.router.navigate(['/plans'], { queryParams: {isSub: true}});
// }